<!-- ReceiptPrint.vue -->
<template>
  <div :class="['receipt-container', ishide ? 'hidden' : '']">
    <!-- Header -->
    <div class="receipt-header">
      <h1 class="store-name">{{ storeName }}</h1>
      <p class="store-address">{{ storeAddress }}</p>
      <p class="store-phone">{{ storePhone }}</p>
    </div>

    <div class="receipt-divider">================================</div>

    <!-- Transaction Info -->
    <div class="receipt-info">
      <div v-for="(detail, index) in viewdetailtransaksi" :key="index" class="info-row">
        <span>{{ detail.field }}:</span>
        <span v-if="detail.type == 'rupiah'">{{
          formatPrice(detail.value)
        }}</span>
        <span v-if="detail.type == 'date'">{{ formatDate(detail.value) }}</span>
        <span v-else>{{ detail.value }}</span>
      </div>
    </div>

    <div class="receipt-divider">================================</div>

    <!-- Items -->
    <div class="receipt-items">
      <div v-for="(item, index) in items" :key="index" class="item">
        <div class="item-row">
          <div class="item-name">{{ item.name }}</div>
          <div v-if="item.discount_price > 0 && item.status != 'canceled'" class="item-name">
            Discount :
          </div>
          <div v-if="item.discount_applied && item.globalDiscountAmount > 0 && item.status != 'canceled'"
            class="item-name">
            {{ currentGlobalDiscount?.name }} :
          </div>
        </div>
        <div class="item-row">
          <div class="item-detail">
            {{ item.quantity }} x {{ formatPrice(item.price) }}
          </div>
          <div v-if="item.discount_price > 0 && item.status != 'canceled'" class="item-total">
            -{{
              formatPrice(
                (item.discount_price > 0
                  ? item.discount_price * item.quantity
                  : 0)
              )
            }}
          </div>
          <div
            v-if="item.discount_applied && item.globalDiscountAmount > 0 && item.status != 'canceled' && currentGlobalDiscount"
            class="item-total">
            -{{
              formatPrice(
                (item.globalDiscountAmount > 0
                  ? item.globalDiscountAmount * item.quantity
                  : 0)
              )
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="receipt-divider">================================</div>

    <!-- Totals -->
    <div class="receipt-totals">
      <div v-for="(detail, index) in viewdetailtotal" :key="index" class="total-row">
        <span>{{ detail.field }}:</span>
        <span v-if="detail.type != 'rupiah'">{{ detail.value }}</span>
        <span v-else>{{ formatPrice(detail.value) }}</span>
      </div>
    </div>

    <div class="receipt-divider">================================</div>

    <!-- Footer -->
    <div class="receipt-footer">
      <p>Terima Kasih Atas Pembelian Anda!</p>
    </div>

    <!-- Tambahkan sebelum footer -->
    <div class="receipt-qr">
      <img :src="selectedQris(new Date()).image" alt="QR Bank" style="width:100px; height:100px;" />
      <div>{{ selectedQris(new Date()).name }}</div>
      <div>Scan untuk pembayaran</div>
    </div>
  </div>
</template>

<script>import { selectedQris } from "@/helpers/qris";

export default {
  name: "BillPrint",
  props: {
    storeName: {
      type: String,
      default: process.env.VUE_APP_STORE_NAME,
    },
    storeAddress: {
      type: String,
      default: process.env.VUE_APP_STORE_ADDRESS,
    },
    storePhone: {
      type: String,
      default: process.env.VUE_APP_STORE_PHONE,
    },
    currentGlobalDiscount: {
      type: Object,
      default: () => { },
    },
    viewdetailtransaksi: {
      type: Array,
      default: () => [
        {
          field: "No. Invoice",
          value: "MAKLO10",
          type: "text",
        },
        {
          field: "Tanggal",
          value: new Date(),
          type: "date",
        },
        {
          field: "Nama Tamu",
          value: "Erista",
          type: "text",
        },
        {
          field: "Kasir",
          value: "Erista Dwatiga",
          type: "text",
        },
        {
          field: "Marketing",
          value: "Erista Dwatiga",
          type: "text",
        },
      ],
    },
    items: {
      type: Array,
      default: () => [
        {
          name: "Sate",
          quantity: 1,
          subtotal: 10000,
          discount_price: 100,
        },
        {
          name: "Nasi Goreng",
          quantity: 1,
          subtotal: 10000,
          discount_price: 0,
        },
      ],
    },
    viewdetailtotal: {
      type: Array,
      default: () => [
        {
          field: "Subtotal",
          value: 10000,
          type: "rupiah",
        },
        {
          field: "Tax",
          value: 1000,
          type: "rupiah",
        },
        {
          field: "Service Charge",
          value: 1000,
          type: "rupiah",
        },
        {
          field: "Total Diskon",
          value: 1000,
          type: "rupiah",
        },
      ],
    },
    ishide: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      date: new Date(this.viewdetailtransaksi?.find(d => d.field === 'Tanggal')?.value || new Date()).getDate(),
      qris: [
        {
          name: "BCA",
          start_date: "1",
          image: "/qr_code_bca.png",
        },
        {
          name: "BNI",
          start_date: "11",
          image: "/qr_code_bni.png",
        },
        {
          name: "MANDIRI",
          start_date: "21",
          image: "/qr_code_mandiri.png",
        },
      ]
    };
  },
  methods: {
    selectedQris,
    formatPrice(price) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(price);
    },
    formatDate(date) {
      return new Intl.DateTimeFormat("id-ID", {
        dateStyle: "medium",
        timeStyle: "short",
      }).format(date);
    },
  },
};
</script>

<style>
@media print {
  @page {
    margin-left: 0;
    size: 63.4mm auto;
  }

  body * {
    visibility: hidden;
  }

  .receipt-container,
  .receipt-container * {
    visibility: visible;
    font-family: "Courier New", monospace !important;
    white-space: pre-wrap !important;
  }

  .receipt-container {
    position: absolute;
    left: 0;
    top: 0;
    width: 63.4mm !important;
  }
}

.receipt-container {
  width: 63.4mm;
  padding: 1mm;
  font-family: "Courier New", monospace !important;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  white-space: pre-wrap;
  box-sizing: border-box;
}

.receipt-header {
  margin-bottom: 10px;
}

.store-name {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 5px 0;
}

.store-address,
.store-phone {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
}

.receipt-divider {
  margin: 5px 0;
  font-size: 12px;
  font-weight: 600;
}

.receipt-info {
  text-align: left;
  margin: 10px 0;
  font-weight: 600;
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin: 2px 0;
  font-weight: 600;
  width: 100%;
}

.receipt-items {
  text-align: left;
  margin: 10px 0;
  font-weight: 600;
}

.item {
  margin: 5px 0;
  font-weight: 600;
  width: 100%;
}

.item-name {
  font-weight: 600;
}

.item-detail {
  font-size: 12px;
  font-weight: 600;
}

.item-discount {
  font-size: 12px;
  text-align: right;
  margin-top: 2px;
  font-weight: 600;
}

.item-total {
  text-align: right;
  font-weight: 600;
}

.receipt-totals {
  text-align: right;
  margin: 10px 0;
}

.item-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin: 2px 0;
  font-weight: 600;
  width: 100%;
  white-space: nowrap;
}

.total-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin: 2px 0;
  font-weight: 600;
  width: 100%;
  white-space: pre-wrap;
}

.grand-total {
  font-weight: 600;
  font-size: 14px;
}

.receipt-footer {
  margin-top: 10px;
  font-size: 11px;
  font-weight: 600;
}

.receipt-footer p {
  margin: 2px 0;
  font-weight: 600;
}

.receipt-qr {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
  width: 100%;
  text-align: center;
  font-weight: 600;
}

.receipt-qr img {
  display: block;
  margin: 0 auto;
}
</style>
